import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { useAppDispatch } from '@/app/store/hooks';
import type { ApiError } from '@/entities/api-response/types';

import { login } from '../api/login';
import {
  type LoginInput,
  type LoginResponse,
} from '../model/auth.schema';
import { sessionEstablished, sessionStarted } from '../model/auth.slice';

export function useLogin(): UseMutationResult<LoginResponse, ApiError, LoginInput> {
  const dispatch = useAppDispatch();

  return useMutation<LoginResponse, ApiError, LoginInput>({
    mutationFn: login,
    onMutate: () => {
      dispatch(sessionStarted());
    },
    onSuccess: (data) => {
      dispatch(
        sessionEstablished({
          user: data.user,
          accessToken: data.accessToken,
        }),
      );
    },
  });
}
